import { UUID } from "../generic/uuid";
import {
  createSupplierDtoFromAnalyticSupplierModel,
  SupplierModel,
} from "./supplier";
import {
  createVintageProductDtoFromAnalyticVintageProductModel,
  VintageProductModel,
} from "./vintageProduct";
import { createPriceDtoFromAnalyticPriceModel, PriceModel } from "./price";
import { createSellerDtoFromAnalyticSellerModel, SellerModel } from "./seller";
import { OfferDto, VintageProductDto } from "@vini-wine/core-dtos";

export interface OfferModel extends UUID {
  // default includes
  price: PriceModel | null;

  // transform
  quantity: number;
  createdAt: Date;

  // available includes
  seller?: SellerModel | null;
  supplier?: SupplierModel | null;
  vintageProducts?: VintageProductModel[];
  lastSupplierOffer?: OfferModel | null;
}

export const createOfferDtoFromAnalyticOfferModel = (
  offer: OfferModel,
): OfferDto => {
  const vintageProducts: VintageProductDto[] = [];
  if (offer.vintageProducts && offer.vintageProducts.length) {
    for (let i = 0; i < offer.vintageProducts.length; i += 1) {
      vintageProducts.push(
        createVintageProductDtoFromAnalyticVintageProductModel(
          offer.vintageProducts[i],
        ),
      );
    }
  }

  return {
    uuid: offer.uuid,
    createdAt: offer.createdAt,
    price: offer.price
      ? createPriceDtoFromAnalyticPriceModel(offer.price)
      : null,
    quantity: offer.quantity,
    seller: offer.seller
      ? createSellerDtoFromAnalyticSellerModel(offer.seller)
      : undefined,
    supplier: offer.supplier
      ? createSupplierDtoFromAnalyticSupplierModel(offer.supplier)
      : undefined,
    vintageProducts,
  };
};
